import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import $ from 'jquery';
import { ModalService } from '../../util/modal.service';
import { Product, ProductConfig } from '../../models/product';



@Component({
  selector: 'products-table',
  templateUrl: './products-table.component.html',
  styleUrls: ['./products-table.component.scss']
})
export class ProductsTableComponent implements OnInit{

  @ViewChild('modal', { static: true }) modal!: ElementRef<HTMLDivElement>;
  @Input() products: any;
  @Input() isColaborator: boolean | undefined;
  @Input() isManager: boolean | undefined;
  @Input() subsidiary: any;
  @Input() actualSearch: any;
  @Input() selectedProduct: Product | undefined

  constructor( private _route: Router,
              private _modalService: ModalService,
  ){ }

  ngOnInit(): void {
    // this._modalService.showModalInfo()
  }


  listConfig(el: Event) {
    const element = el.currentTarget as HTMLElement;
    $(element).children('.box').toggleClass('d-none');
  }

  selectConf(el: Event, conf: ProductConfig) {
    const elemnt = el.currentTarget as HTMLElement;
    // @ts-ignore
    $(elemnt).parent().parent().prev().html('S/ ' + conf.price.toString())
    // @ts-ignore
    $(elemnt).parent().parent().next().html(conf.unitAvailable.toString())
  }

  editar(product: Product) {
    this._route.navigate(['/members/product/detailProduct', product.productId])
  }

  eliminar(product: Product) {
    this.selectedProduct = product
    $('table .box').addClass('d-none')
    // @ts-ignore
    this.modal.nativeElement.classList.remove('d-none')
  }

  toggleOptions(e: HTMLImageElement | null) {
    // @ts-ignore
    let div: HTMLElement = e.parentElement
    if (div.classList.contains('options')) {
      // @ts-ignore
      div.querySelector('.box').classList.toggle('d-none')
    }

  }


}
